import { Header, Footer, How, Features, ProductShowcase, Sectors } from "@/pages/LandingPage";
import { useLang } from "@/i18n";
import { PatternDivider } from "@/components/EthnicPatterns";

export default function FeaturesPage() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-af">
      <Header />
      <section className="max-w-4xl mx-auto px-6 pt-16 md:pt-20 pb-4 text-center">
        <PatternDivider />
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl mt-4" data-testid="features-page-title">
          {t.featuresPage.title}
        </h1>
        <p className="mt-4 text-af-secondary max-w-2xl mx-auto">{t.featuresPage.sub}</p>
      </section>
      <Features />
      <How />
      <ProductShowcase />
      <Sectors />
      <Footer />
    </div>
  );
}
